import NiceModal from '@ebay/nice-modal-react';
import { useUserEventLogger } from '@repo/tracking-service';
import { TermDrawer } from '@repo/user-sign';
import { List } from '@zenterprise-inc/ui';

export type TermsItem = {
  label: string;
  link: string;
  clickEvent: string;
};

export const PolicyListItem = ({ label, link, clickEvent }: TermsItem) => {
  const { sendClickEvent } = useUserEventLogger();

  const handleOpenTermDrawer = () => {
    sendClickEvent(clickEvent);
    NiceModal.show(TermDrawer, { link, keepMounted: true });
  };

  return (
    <li>
      <List.Basic title={{ text: label }} listIcon onClick={handleOpenTermDrawer} />
    </li>
  );
};
